import {useEffect, useState} from 'react';
import {SavingIndicatorState} from './saving-indicator';

export const MINIMAL_LOADING_TIME_MS = 1000;
export const SAVED_STATE_TRANSITION_TIME_MS = 2000;

export const useSavingTransitionState = (isSaving: boolean, hasFailed: boolean) => {
  const [state, setState] = useState<SavingIndicatorState>('idle');

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (isSaving) {
      setState('saving');
    } else {
      timeout = setTimeout(() => {
        if (hasFailed) {
          setState('error');
        } else {
          setState('saved');
          timeout = setTimeout(() => {
            setState('idle');
          }, SAVED_STATE_TRANSITION_TIME_MS);
        }
      }, MINIMAL_LOADING_TIME_MS);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [hasFailed, isSaving, setState]);

  return state;
};
